<div class="login-popup-container" [@fadeInOut]>
    <div class="login-popup centered-txt">
        <div class="header-font">{{title}}</div>
        <div class="login-popup-content font">
            {{text}}
        </div>
        <simple-btn class="login-popup-button-ok"
                    [hoverTextColor]="'white'"
                    [backgroundFillCls]="'o2Background'"
                    [hoverFillCls]="'o1Background'"
                    [boxShadowCls]="'primary-shadow'"
                    [text]="'Ok'"
                    [textCls]="'large-btn-text-500'"
                    [height]="50"
                    [cornerRadius]="50"
                    [horizontalPadding]="20"
                    (click)="closePopup()"
                    [width]="95"
                    data-testid="login-popup-button-ok">
        </simple-btn>
    </div>
</div>